function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 18.3957C18 19.5158 18.9018 20.2746 20 20.2746C21.1161 20.2746 22 19.5158 22 18.3957V3.88799C22 2.75881 21.1161 2 20 2C18.9018 2 18 2.75881 18 3.88799V18.3957ZM9 15.6405C11.6518 15.9566 14.5089 16.7425 17 18.0343V4.31256C14.4911 5.61337 11.4196 6.43541 9 6.70641V15.6405ZM5.86607 6.70641C3.33929 6.70641 2 8.02529 2 10.4824V11.8555C2 14.3126 3.33929 15.6314 5.86607 15.6314H8V6.70641H5.86607ZM9.5625 22C10.6964 22 11.5268 21.2051 11.2321 19.7868L10.6429 16.9684C10.1875 16.7877 8.77679 16.6883 8.08929 16.6793H5.79464L7.48214 20.383C7.95536 21.4128 8.5 22 9.5625 22Z",
  fill: "#939EAA"
});

function SvgMarketingCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCampaigns);
export default __webpack_public_path__ + "static/media/marketing-campaigns.5c53f561.svg";
export { ForwardRef as ReactComponent };